
import BlogTextColor from '~/components/Common/Blog/BlogTextColor'

export default {
    name: 'CrudeOilPrice',
    components: { BlogTextColor },
}
